"use strict";

export var FormReportConstants = {
  FORM_REPORT_INITIALIZE: 'FORM_REPORT_INITIALIZE',
  FORM_REPORT_NAVIGATE_TO_PARENT: 'FORM_REPORT_NAVIGATE_TO_PARENT',
  FORM_REPORT_APPLY: 'FORM_REPORT_APPLY',
  FORM_REPORT_UPDATE: 'FORM_REPORT_UPDATE'
};